<template>
	<component :is="tag" class="cms-post-title" :style="titleStyle">{{ title }}</component>
</template>

<script>
/**
 * PostTitleBlock.vue
 * ──────────────────
 * The article headline, for Article templates. Reads the post from the filled
 * `post` prop (public site) or the editor's preview post (`cmsPostPreview`);
 * see blocks/shared/postContext.js. Level and alignment are the block's own;
 * font and colour come from the site h1/h2 styles or the Typography trait.
 */
import { buildHeadingLevelStyle } from '@/websites/cms/blocks/headingBlock/headingLevelStyle.js';
import { resolvePost } from '@/websites/cms/blocks/shared/postContext.js';

export default {
	name: 'PostTitleBlock',

	inject: {
		cmsPostPreview: { default: null }
	},

	props: {
		level: { type: String, default: 'h1' },
		align: { type: String, default: 'left' },
		/** Filled by the server for the post being rendered; absent in the editor. */
		post: { type: Object, default: null }
	},

	computed: {
		tag: function () {
			return this.level === 'h2' ? 'h2' : 'h1';
		},

		title: function () {
			return resolvePost(this.post, this.cmsPostPreview).websitePostTitle || '';
		},

		titleStyle: function () {
			var s = buildHeadingLevelStyle(this.tag) || {};
			s.textAlign = this.align || 'left';
			return s;
		}
	}
};
</script>

<style scoped>
.cms-post-title {
	margin: 0;
	width: 100%;
	max-width: 100%;
	word-wrap: break-word;
	overflow-wrap: break-word;
	text-wrap: balance;
}
</style>
